<template>
  <div>
    <el-table :data="items">
      <el-table-column
        align="center"
        label="名称"
        prop="name"
      ></el-table-column>
      <el-table-column
        align="center"
        label="直径"
        prop="diameter"
      ></el-table-column>
      <el-table-column
        align="center"
        label="齿形"
        prop="tooth_type"
      ></el-table-column>
      <el-table-column
        align="center"
        label="等级"
        prop="grade"
      ></el-table-column>
      <el-table-column
        align="center"
        label="数量"
        prop="number"
      ></el-table-column>
      <el-table-column align="center" label="创建时间" min-width="120">
        <template slot-scope="scope">{{
          $time(scope.row.created_at).format('YYYY-MM-DD')
        }}</template>
      </el-table-column>
      <el-table-column label="仓库" align="center" prop="stockroom.name">
      </el-table-column>
      <el-table-column align="center" label="操作">
        <template slot-scope="scope">
          <btn-tag
            :btn="true"
            text="详情"
            :key="Math.random()"
            :auth-id="51201"
            module-name="stock"
            @click.native="handleShow(scope.row)"
          ></btn-tag>
          <!-- <btn-tag
            v-if="currentUser.id == scope.row.stockroom.user_id"
            :btn="true"
            text="编辑"
            :key="Math.random()"
            :auth-id="51201"
            module-name="stock"
            @click.native="editItem(scope.row, scope.$index)"
          ></btn-tag>
          <btn-tag
            :btn="true"
            text="删除"
            :key="Math.random()"
            :auth-id="51201"
            btn-class="btn-danger"
            @click.native="hanldeDelte(scope.row, scope.$index)"
          ></btn-tag> -->
        </template>
      </el-table-column>
    </el-table>

    <pdc-former
      :model="model"
      :show.sync="formerVisible"
      @updated="updatedCallback"
    ></pdc-former>
    <item-detail :model="model" :show.sync="detailVisible"></item-detail>
  </div>
</template>

<script>
import { pdcDelete } from '@/service/getData'
import PdcFormer from '@/components/pdc_former'
import ItemDetail from '@/components/pdc_detail'
import { deepClone } from '@/utils'
import { getStore } from '@/config/mUtils'

export default {
  components: {
    PdcFormer,
    ItemDetail,
  },
  props: {
    items: null,
    admin: false,
  },
  data() {
    return {
      currentUser: getStore('userInfo'),
      model: {},
      formerVisible: false,
      detailVisible: false,
      editIndex: 0,
    }
  },
  methods: {
    handleShow(item) {
      this.model = item
      this.detailVisible = true
    },
    editItem(item, index) {
      this.model = deepClone(item)
      this.editIndex = index
      this.formerVisible = true
    },
    updatedCallback(data) {
      this.$set(this.items, this.editIndex, data)
    },
    hanldeDelte(item, index) {
      let that = this
      that.$dialog.confirm('确认删除吗').then(function (dialog) {
        pdcDelete(item.id).then((res) => {
          if (res.status == 0) {
            that.items.splice(index, 1)
          }
        })
      })
    },
  },
}
</script>